function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onClose", "openModal", "children", "renderMembershipForm", "modalClasses", "formClasses"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import Modal from "@xo-union/tk-component-modals";
import classesPropType from "@xo-union/classes-prop-type";
import { useClassesMapper, compose } from "@xo-union/react-css-modules";
import { MembershipForm, CanSpam, SignUpForm, LogInForm } from "@xo-union/tk-ui-membership-form";
import styles from "./styles.css";
var membershipFormClasses = compose({
  formContainer: styles.membershipForm
});
var defaultRenderMembershipForm = function defaultRenderMembershipForm(props, ref) {
  return /*#__PURE__*/React.createElement(MembershipForm, _extends({
    ref: ref
  }, props));
};
var MembershipModal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var onClose = _ref.onClose,
    formType = _ref.openModal,
    children = _ref.children,
    renderMembershipForm = _ref.renderMembershipForm,
    modalClasses = _ref.modalClasses,
    formClasses = _ref.formClasses,
    rest = _objectWithoutProperties(_ref, _excluded);
  var emailInputRef = React.useRef(null);
  var classes = useClassesMapper(membershipFormClasses, formClasses);
  return /*#__PURE__*/React.createElement(CanSpam, null, function (_ref2) {
    var ready = _ref2.ready;
    if (!formType || !ready) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Modal, {
      size: "sm",
      onClose: onClose,
      classes: modalClasses
    }, renderMembershipForm(_objectSpread({
      formType: formType,
      initialFocusRef: emailInputRef,
      classes: classes
    }, rest), ref), children);
  });
});
process.env.NODE_ENV !== "production" ? MembershipModal.propTypes = {
  renderMembershipForm: PropTypes.func,
  /**
   * Name of open modal
   */
  openModal: PropTypes.oneOf(['SIGN_UP', 'LOG_IN', null]),
  /**
   * Callback called when clicking on the Log In link
   */
  onClickLogIn: PropTypes.func.isRequired,
  /**
   * Callback called when clicking on the Sign Up link
   */
  onClickSignUp: PropTypes.func.isRequired,
  /**
   * Callback called when the Sign Up form is submitted
   */
  onSignUp: PropTypes.func,
  /**
   * Callback called when the Log In form is submitted
   */
  onLogIn: PropTypes.func,
  /**
   * Callback when overlay (on desktop) or X (on mobile) is clicked
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Metadata about user action necessary for sign up form
   */
  metadata: PropTypes.shape({
    userAction: PropTypes.string.isRequired,
    applicationName: PropTypes.string.isRequired
  }).isRequired,
  /**
   * Whether or not we are waiting for a membership response. Used to render the "loading" state of
   * the modals
   */
  inProgress: PropTypes.bool,
  /**
   * @private Used internally. This will be ignored if passed to component
   */
  children: PropTypes.node,
  /**
   * Signup view. Defaults to SignUpForm
   */
  SignUpView: PropTypes.func,
  /**
   * Login view. Defaults to LogInForm
   */
  LogInView: PropTypes.func,
  /**
   * Login class dependencies. Check the Override example in [Storybook] (https://docs.union.theknot.com/storybook/?path=/story/patterns-membershipmodal--override)
   */
  modalClasses: classesPropType(),
  /**
   * Form class dependencies. Check the Override example in [Storybook] (https://docs.union.theknot.com/storybook/?path=/story/patterns-membershipmodal--override)
   */
  formClasses: classesPropType()
} : void 0;
MembershipModal.defaultProps = {
  children: null,
  openModal: null,
  SignUpView: SignUpForm,
  LogInView: LogInForm,
  renderMembershipForm: defaultRenderMembershipForm
};
export default MembershipModal;